module.exports = __webpack_public_path__ + "images/04_79dab6ca.png";